function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { render } from "@testing-library/react";
import { scaleLinear, scaleTime } from "@visx/scale";
import maxBy from "lodash-es/maxBy";
import minBy from "lodash-es/minBy";
import MomentPointsChart from "../../../../lib/ReactViews/Custom/Chart/MomentPointsChart";
import { jsx as _jsx } from "react/jsx-runtime";
function parseGlyphPositions(container) {
  const glyphs = container.querySelectorAll("g.visx-glyph");
  return Array.from(glyphs).map(g => {
    var _match$, _match$2;
    const transform = g.getAttribute("transform") || "";
    const match = transform.match(/translate\(\s*([^,\s]+)\s*,\s*([^)]+)\s*\)/);
    return {
      left: parseFloat((_match$ = match === null || match === void 0 ? void 0 : match[1]) !== null && _match$ !== void 0 ? _match$ : "0"),
      top: parseFloat((_match$2 = match === null || match === void 0 ? void 0 : match[2]) !== null && _match$2 !== void 0 ? _match$2 : "0")
    };
  });
}
describe("MomentPointsChart", function () {
  const chartItem = {
    id: "chartitem",
    item: {},
    categoryName: "Points chart",
    key: "key-chartitem",
    name: "chartitem",
    type: "momentPoints",
    xAxis: {
      name: "xAxis",
      scale: "time"
    },
    points: [{
      x: new Date("2020-05-25"),
      y: 0.5
    }, {
      x: new Date("2020-05-26"),
      y: 0.5
    }, {
      x: new Date("2020-05-27"),
      y: 0.5
    }, {
      x: new Date("2020-05-28"),
      y: 0.5
    }, {
      x: new Date("2020-05-29"),
      y: 0.5
    }, {
      x: new Date("2020-05-30"),
      y: 0.5
    }],
    domain: {
      x: [new Date("2020-05-25").valueOf(), new Date("2020-05-30").valueOf()],
      y: [0.5, 0.5]
    },
    getColor: () => "red",
    onClick: () => {},
    showInChartPanel: true,
    isSelectedInWorkbench: true,
    updateIsSelectedInWorkbench: () => {}
  };
  const scales = getScales(chartItem.points);
  const props = {
    id: "testid",
    chartItem,
    scales: {
      x: scales.x,
      y: scales.y.domain([0, 1])
    }
  };
  it("renders all points", function () {
    const {
      container
    } = render(/*#__PURE__*/_jsx("svg", {
      children: /*#__PURE__*/_jsx(MomentPointsChart, _objectSpread({}, props))
    }));
    const glyphs = container.querySelectorAll("g.visx-glyph");
    expect(glyphs.length).toBe(6);
  });
  it("renders the points at the correct positions", function () {
    const {
      container
    } = render(/*#__PURE__*/_jsx("svg", {
      children: /*#__PURE__*/_jsx(MomentPointsChart, _objectSpread({}, props))
    }));
    const positions = parseGlyphPositions(container);
    const xs = [0, 2, 4, 6, 8, 10];
    positions.forEach((pos, i) => {
      expect(pos.left).toEqual(xs[i]);
      expect(pos.top).toEqual(5);
    });
  });
  it("renders the correct type of glyph", function () {
    const {
      container
    } = render(/*#__PURE__*/_jsx("svg", {
      children: /*#__PURE__*/_jsx(MomentPointsChart, _objectSpread(_objectSpread({}, props), {}, {
        glyph: "square"
      }))
    }));
    const glyphs = container.querySelectorAll("g.visx-glyph");
    expect(glyphs.length).toBe(6);
  });
  describe("when a basis item is provided", function () {
    it("renders the points on the basis item", function () {
      const basisItem = _objectSpread(_objectSpread({}, chartItem), {}, {
        name: "basisitem",
        points: chartItem.points.map((_ref, i) => {
          let {
            x
          } = _ref;
          return {
            x,
            y: [0, 10, 2, 5, 8, 6][i]
          };
        })
      });
      const basisItemScales = getScales(basisItem.points);
      const propsWithBasisItem = _objectSpread(_objectSpread({}, props), {}, {
        basisItem,
        basisItemScales
      });
      const {
        container
      } = render(/*#__PURE__*/_jsx("svg", {
        children: /*#__PURE__*/_jsx(MomentPointsChart, _objectSpread({}, propsWithBasisItem))
      }));
      const positions = parseGlyphPositions(container);
      const xs = [0, 2, 4, 6, 8, 10];
      const ys = [0, 10, 2, 5, 8, 6];
      positions.forEach((pos, i) => {
        expect(pos.left).toEqual(xs[i]);
        expect(pos.top).toEqual(ys[i]);
      });
    });
  });
});
function getScales(points) {
  const xs = points.map(p => p.x);
  const ys = points.map(p => p.y);
  const xDomain = [minBy(xs, d => d.getTime()), maxBy(xs, d => d.getTime())];
  const yDomain = [Math.min(...ys), Math.max(...ys)];
  return {
    x: scaleTime({
      domain: xDomain,
      range: [0, 10]
    }),
    y: scaleLinear({
      domain: yDomain,
      range: [0, 10]
    })
  };
}